import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { axios } from "./axios";

export const useDeleteBrandingLogo = () => {
  const { authHeader } = useAuth();

  return useMutation(({ id }: { id: number }) => {
    return axios.delete(
      `${env.verifyServiceUrl}individual/splash_screen/${id}/delete_logo`,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
